import BaseModel from './base';

export default class Expertise extends BaseModel {
  constructor(expertise) {
    super(expertise);

    this.appraisals = expertise?.appraisals || [];
    this.comment = expertise?.comment || null;
    this.created_at = expertise?.created_at || null;
    this.is_complete = expertise?.is_complete || false;
    this.owner = expertise?.owner || null;
  }
}
